"use client";

import { X } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { LocaleSwitcher } from "@/components/core/LocaleSwitcher";
import { NetworkMenu } from "@/components/core/NetworkMenu/NetworkMenu";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useSidebar } from "@/context/sidebar";

export const Sidebar = () => {
  const t = useTranslations("nav");
  const locale = useLocale();
  const { isOpen, setIsOpen } = useSidebar();
  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetContent
        title={t("menu")}
        className="w-[85vw] max-w-88 overflow-y-auto bg-bg-primary! px-5! pt-16! pb-8! motion-reduce:animate-none"
        aria-describedby={undefined}
        side={locale === "en" ? "left" : "right"}
      >
        <Button
          variant="light"
          size="icon"
          className="absolute end-4 top-4"
          aria-label={t("closeMenu")}
          onClick={() => setIsOpen(false)}
        >
          <X size={20} />
        </Button>
        <div className="mb-6">
          <LocaleSwitcher onSelect={() => setIsOpen(false)} />
        </div>
        <NetworkMenu onNavigate={() => setIsOpen(false)} />
      </SheetContent>
    </Sheet>
  );
};
